import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ServiceSidebar from './ServiceSidebar';
import ServiceTopNav from './ServiceTopNav';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../../admin/layout/style/Layout.css'; 

const ServiceLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const toggleSidebarCollapse = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  // Close sidebar on route change in mobile view
  useEffect(() => {
    if (window.innerWidth <= 768) {
      setSidebarOpen(false);
    }
  }, [location]);

  // Close sidebar on window resize if screen becomes larger
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768)  {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className={`admin-layout ${sidebarOpen ? 'sidebar-open' : ''} ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
      <ServiceSidebar 
        isOpen={sidebarOpen} 
        toggleSidebar={toggleSidebar}
        collapsed={sidebarCollapsed}
        onToggleCollapse={toggleSidebarCollapse}
      />
      <div className="content-wrapper">
        <ServiceTopNav 
          toggleSidebar={toggleSidebar} 
          isOpen={sidebarOpen}
          sidebarCollapsed={sidebarCollapsed}
        />

        <main className="main-content">
          <Outlet />
        </main>
      </div>
      {sidebarOpen && (
        <div 
          className={`sidebar-overlay ${sidebarOpen ? 'show' : ''}`} 
          onClick={toggleSidebar}
        />
      )}
    </div>
  );
};

export default ServiceLayout;
